import { useTenant } from "@/hooks/useTenant";
import { portalFetch } from "@/lib/portalApi";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export type PortalDomain = {
  id: string;
  tenantId: string;
  domain: string;
  createdAt: string;
};

export function useDomains() {
  const { currentTenantId } = useTenant();

  const { data, isLoading } = useQuery({
    queryKey: ["portal-domains", currentTenantId],
    queryFn: () => portalFetch<PortalDomain[]>(`/api/portal/tenants/${currentTenantId}/domains`),
    enabled: !!currentTenantId,
  });

  return { domains: data ?? [], isLoading };
}

export function useAddDomain() {
  const { currentTenantId } = useTenant();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (domain: string) =>
      portalFetch<PortalDomain>(`/api/portal/tenants/${currentTenantId}/domains`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tenantId: currentTenantId, domain }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["portal-domains"] }),
  });
}

export function useRemoveDomain() {
  const { currentTenantId } = useTenant();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (id: string) =>
      portalFetch(`/api/portal/tenants/${currentTenantId}/domains/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tenantId: currentTenantId, id }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["portal-domains"] }),
  });
}
